import { render, staticRenderFns } from "./Logement.vue?vue&type=template&id=6dc31bf6"
import script from "./Logement.vue?vue&type=script&lang=js"
export * from "./Logement.vue?vue&type=script&lang=js"
import style0 from "./Logement.vue?vue&type=style&index=0&id=6dc31bf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports